import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  elements: any[];
}
const LinearProgress = ({ elements }: IProps): React.ReactElement => {
  const [animBar, setAnimBar] = useState<number>(0);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimBar(0);
    }, 1000 * 60);

    setAnimBar(100);

    return () => {
      clearTimeout(timeout);
    };
  }, [elements]);

  return (
    <Box width="100%" position="absolute" top="30px" zIndex={3} margin="-30px -30px 30px -30px">
      <Box
        height="5px"
        bgcolor="#1886cf"
        width={`${animBar}%`}
        style={{ transition: animBar === 0 ? ".2s width" : "70s width linear" }}
      ></Box>
    </Box>
  );
};

export default LinearProgress;
